module.exports = __webpack_public_path__ + "static/media/gator-32.6937350f.svg";